import React from "react";
import { Dialog } from "@mui/material";
import { noop } from "utils/General";

import Slide from "@mui/material/Slide";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const BottomSheetExample = ({ children, open = false, handleClose = noop }) => {
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        PaperProps={{
          style: {
            position: "absolute",
            bottom: 0,
            margin: 0,
            width: "100%",
            borderRadius: "8px 8px 0 0"
          }
        }}
      >
        {children}
      </Dialog>
    </div>
  );
};

export default BottomSheetExample;
